import { connect } from 'react-redux';
import {
    addOrderPosition,
    selectIsAddingPositionAllowed,
    selectOrderContext,
    selectSessionError,
    selectIsAddPositionDisabled
} from 'src/modules/Order';
import { selectRestaurant } from 'src/modules/Restaurant';
import { emitMessage, dismissFirstMessage } from 'src/modules/Modal';
import { getUrl, getSrcSetUrls } from 'src/utils/image';

const mapDispatchToProps = {
    addOrderPosition,
    emitMessage,
    dismissFirstMessage
};

const mapStateToProps = (state, { imageId }) => ({
    canAddPosition: selectIsAddingPositionAllowed(state),
    imageUrl: imageId
        ? getUrl(selectRestaurant(state).id, imageId, 'rt:fill/size:400:200/g:ce/q:85')
        : null,
    imageSrcSetUrls: imageId
        ? getSrcSetUrls(selectRestaurant(state).id, imageId, 'rt:fill/size:400:200/g:ce/q:85')
        : null,
    context: selectOrderContext(state),
    sessionError: selectSessionError(state),
    isAddPositionDisabled: selectIsAddPositionDisabled(state)
});

export default connect(mapStateToProps, mapDispatchToProps);
